import { Box, Typography, Link, Divider } from "@mui/material";
import CustomUploadFileV2 from "@components/CustomUploadFileV2";
import { BofuTabCode, BofuTabDocument, DocumentResponse } from "@interfaces/response";
import React from "react";

interface InputUploadDocumentProps {
  inputPrefix?: string;
  docItem: BofuTabDocument;
  onChange?: (params: {
    newValue: DocumentResponse | undefined;
    document: BofuTabDocument;
    subAction?: "add" | "remove" | "update" | null;
  }) => void;
  onChangeMultiple?: (params: {
    newValue: DocumentResponse | undefined;
    document: BofuTabDocument;
    valueAction?: "add" | "remove" | "update" | null;
    valueIndex?: number;
  }) => void;
  documentIndex: number;
  uploadService?: "default" | "second_guarantee";
}

const UploadMultipleDocument = ({
  inputPrefix,
  docItem,
  onChangeMultiple,
  documentIndex,
  uploadService,
}: InputUploadDocumentProps) => {
  const { list_values } = docItem;
  return (
    <Box>
      {docItem?.list_values?.map((valueItem, valueIndex) => (
        <React.Fragment key={`${inputPrefix}_multiple_document_${documentIndex}_${valueIndex}`}>
          <CustomUploadFileV2
            py={2}
            inputName={`${inputPrefix || ""}_multiple_document_${documentIndex}_${valueIndex}`}
            optionalName={docItem.name}
            optionalDescription={docItem.label || ""}
            disabled={docItem.disabled}
            uploadedFile={valueItem}
            setUploadedFile={(newValue) => {
              onChangeMultiple?.({ document: docItem, newValue, valueAction: "update", valueIndex });
            }}
            metadata={{
              fileCode: docItem.file_category_code,
              uploadType: docItem.upload_type || "client",
              clientDetailsId: docItem.client_details_id,
              personId: docItem.person_id,
              guaranteeId: docItem.guarantee_id,
            }}
            required={docItem.required}
            uploadService={uploadService || "default"}
            hiddeDivider={true}
          />
        </React.Fragment>
      ))}

      <Box textAlign="right" my={2}>
        <Link
          onClick={() => {
            if (list_values.length && list_values[list_values.length - 1] === undefined) {
              return;
            }
            onChangeMultiple?.({ document: docItem, newValue: undefined, valueAction: "add", valueIndex: undefined });
          }}
          sx={{
            cursor: list_values.length && list_values[list_values.length - 1] === undefined ? "not-allowed" : "pointer",
            opacity: list_values.length && list_values[list_values.length - 1] === undefined ? 0.5 : 1,
          }}
        >
          <Typography variant="body1" fontWeight={400}>
            + Agregar {(docItem.name || "").toLowerCase()}
          </Typography>
        </Link>
      </Box>

      <Divider sx={{ backgroundColor: "#A3D4E8", mt: 2 }} />
    </Box>
  );
};

const UploadSingleDocument = ({
  inputPrefix,
  docItem,
  onChange,
  documentIndex,
  uploadService,
}: InputUploadDocumentProps) => {
  return (
    <React.Fragment>
      <CustomUploadFileV2
        py={2}
        inputName={`${inputPrefix || ""}_single_document_${documentIndex}`}
        optionalName={docItem.name}
        optionalDescription={docItem.label}
        disabled={docItem.disabled}
        uploadedFile={docItem.file_value}
        setUploadedFile={(newValue) => {
          onChange?.({ document: docItem, newValue });
        }}
        metadata={{
          fileCode: docItem.file_category_code,
          uploadType: docItem.upload_type || "client",
          clientDetailsId: docItem.client_details_id,
          personId: docItem.person_id,
          guaranteeId: docItem.guarantee_id,
        }}
        required={docItem.required}
        uploadService={uploadService || "default"}
      />
    </React.Fragment>
  );
};

interface DocumentsTabBofuProps {
  inputPrefix?: string;
  tabCode: BofuTabCode;
  documents: BofuTabDocument[];
  onChange?: (params: { newValue: DocumentResponse | undefined; document: BofuTabDocument }) => void;
  onChangeMultiple?: (params: {
    newValue: DocumentResponse | undefined;
    document: BofuTabDocument;
    valueAction?: "add" | "remove" | "update" | null;
    valueIndex?: number;
  }) => void;
  uploadService?: "default" | "second_guarantee";
  agregarNuevo?: () => void;
}

const DocsEmpresa = (props: DocumentsTabBofuProps) => {
  return (
    <Box>
      {props.documents.map((docItem, index) => (
        <React.Fragment key={docItem.name}>
          {docItem.multiple ? (
            <UploadMultipleDocument
              key={docItem.name}
              inputPrefix={props.inputPrefix}
              docItem={docItem}
              onChangeMultiple={props.onChangeMultiple}
              documentIndex={index}
              uploadService={props.uploadService}
            />
          ) : (
            <UploadSingleDocument
              key={docItem.name}
              inputPrefix={props.inputPrefix}
              docItem={docItem}
              onChange={props.onChange}
              documentIndex={index}
              uploadService={props.uploadService}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default DocsEmpresa;
